import { useContext } from 'react';
import { DropdownContext } from './DropdownContext';

export function useDropdownContext() {
  const context = useContext(DropdownContext);
  if (context === null) {
    throw new Error('useDropdownContext must be used within a DropdownProvider');
  }
  return context;
}
